<template>
<div>

<ContentHeader :title="$store.state.languages.lang_phrases.denetlemeler"  :show_button="false" ></ContentHeader>


<div class="mt-6">
<div class="grid">

<div class="col-2">
<span class="p-float-label">
<MultiSelect v-model="selectedbrands" :options="brands" optionLabel="name" optionValue="id" :loading="brands_loading" filter  class="w-full p-inputtext-sm" @change="getProjects"/>
<label  class="text-primary">{{$store.state.languages.lang_phrases.marka}}</label>
</span>
</div>

<div class="col-2">
<span class="p-float-label">
<MultiSelect v-model="selectedprojects" :options="projects" optionLabel="name" optionValue="id" :loading="projects_loading" filter
      class="w-full p-inputtext-sm" @change="getFlows"/>
<label  class="text-primary">{{$store.state.languages.lang_phrases.proje}}</label>
</span>
</div>

<div class="col-2">
<span class="p-float-label">
<MultiSelect v-model="selectedflows" :options="flows" optionLabel="name" optionValue="id" :loading="flows_loading"  filter
      class="w-full p-inputtext-sm" @change="getAudits"/>
<label  class="text-primary">{{$store.state.languages.lang_phrases.akis}}</label>
</span>
</div>


<div class="col-2">
<span class="p-float-label">
<Calendar v-model="start_date" showIcon showButtonBar @input="getAudits" @date-select="getAudits" @clear-click="getAudits"/>
<label  class="text-primary">{{$store.state.languages.lang_phrases.baslangic_tarihi}}</label>
</span>
</div>
<div class="col-2">
<span class="p-float-label">
<Calendar v-model="end_date" showIcon showButtonBar @input="getAudits" @date-select="getAudits" @clear-click="getAudits"/>
<label  class="text-primary">{{$store.state.languages.lang_phrases.bitis_tarihi}}</label>
</span>
</div>



<div class="col-2">
<span class="p-float-label">
<InputText v-model="searchterm"  class="w-full " @input="searchSupplier" :showClear="true"/>
<label  class="text-primary">{{$store.state.languages.lang_phrases.arama}}</label>
</span>
</div>






</div>
</div>

<template v-if="loading_audits">
<FrameOverlay></FrameOverlay>
</template>

<template v-else>
<div class="mt-4">
<div class="grid">
<div class="col-12">
<DataTable 
:value="audits" 
:paginator="true" 
:lazy="true"
class="p-datatable-suppliers" 
:rows="20"
dataKey="id" 
:rowHover="true"
filterDisplay="menu" 
:loading="loading"
paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
responsiveLayout="scroll"
currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
:totalRecords="totalRecords"
@page="onPage($event)"
:page="page+1"
:first="first"
>
<Column   :header="$store.state.languages.lang_phrases.isim" >
<template #body="slotProps">
<router-link class="text-primary p-link no-underline" :to="{ name: 'Supplier' , params: { id: slotProps.data.flowsupplier.supplier_id }}">{{ slotProps.data.flowsupplier.supplier.name}}</router-link>
</template>
</Column>

<Column   :header="$store.state.languages.lang_phrases.tedarikci_kodu" >
<template #body="slotProps">
<p>{{ slotProps.data.flowsupplier.supplier.suppliercode}}</p>
</template>
</Column>



<Column   :header="$store.state.languages.lang_phrases.marka" >
<template #body="slotProps">
<p>{{ slotProps.data.flowsupplier.flow.brand.name}}</p>
</template>
</Column>

<Column   :header="$store.state.languages.lang_phrases.akis" >
<template #body="slotProps">
<p>{{ slotProps.data.flowsupplier.flow.name}}</p>
</template>
</Column>

<Column   :header="$store.state.languages.lang_phrases.tur" >
<template #body="slotProps">
<template v-if="slotProps.data.flowsupplier.flow.type=='audit'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.audit" 
style="background-color:#352f8d"
/>	
</template>
<template v-if="slotProps.data.flowsupplier.flow.type=='verification'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.verification" 
style="background-color:#7e2f8d"
/>		
</template>

</template>
</Column>

<Column   :header="$store.state.languages.lang_phrases.denetim_zamani" >
<template #body="slotProps">
<p>{{ $filters.momentFormat( slotProps.data.scheduled_at," Do-MM-YYYY HH:mm")}}</p>
</template>
</Column>

<Column   :header="$store.state.languages.lang_phrases.durum" >
<template #body="slotProps">

<template v-if="slotProps.data.flowsupplier.status=='created'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.olusturuldu" 
style="background-color:#352f8d"
/>	
</template>

<template v-if="slotProps.data.flowsupplier.status=='started'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.baslandi" 
style="background-color:#dd4b39"
/>	
</template>

<template v-if="slotProps.data.flowsupplier.status=='finished'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.tamamlandi" 
style="background-color:#4dc247"
/>	
</template>

<template v-if="slotProps.data.flowsupplier.status=='under_review'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.degerlendirmede" 
style="background-color:#ff6600"
/>	
</template>

<template v-if="slotProps.data.flowsupplier.status=='canceled'">
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.iptal_edildi" 
style="background-color:#a82400"
/>	
</template>

</template>
</Column>





</DataTable>

</div>
</div>
</div>
	
</template>




</div>
</template>

<script>
export default {

  name: 'AuditorTechnicalAuditHistory',

  data () {
    return {
    	loading:true,
    	brands_loading:true,
    	projects_loading:true,
    	flows_loading:true,
    	loading_audits:true,
    	brands:[],
    	projects:[],
    	flows:[],
    	audits:[],
    	verifications:[],
    	selectedbrands:[],
    	selectedprojects:[],
    	selectedflows:[],
    	start_date:null,
    	end_date:null,
    	intervalobj:null,
    	searchterm:null,
    	page:0,
    	first:0, 
    	totalRecords:0,
    }
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
  	onPage(event)
  	{
  		this.page = event.page
  		console.log(event)
  		this.getAudits()
  	},
  	searchSupplier()
    {
        
        clearInterval(this.intervalobj);
        this.intervalobj = setInterval(()=>{
            this.getAudits()
            clearInterval(this.intervalobj);
        },1000)
    },
  	async getData()
  	{

  		await this.getBrands() 
  	},
  	async getBrands()
  	{
  		this.brands_loading = true 
  		this.brands = await this.generalApiGetWithoutLoader("brands") 
  		this.brands_loading = false 
  		await this.getProjects()
  	},
  	async getProjects()
  	{ 
  		this.projects_loading = true 
  		this.selectedprojects = []
  		if(this.selectedbrands.length)
  		{
  			let arr = JSON.stringify(this.selectedbrands)
  			this.projects = await this.generalApiGetWithoutLoader("auditable_projects?selected_brands="+arr)
  		}
  		else
  		{
  			this.projects = await this.generalApiGetWithoutLoader("auditable_projects")
  		}
  		

  		this.projects_loading = false
  		await this.getFlows()
  		
  	},
  	async getFlows()
  	{
  		this.flows_loading = true
  		this.selectedflows = []
  		this.page = 0
  		if(this.selectedbrands.length && this.selectedprojects.length)
  		{
  			let arr = JSON.stringify(this.selectedprojects)
  			this.flows = await this.generalApiGetWithoutLoader("auditable_flows?selected_projects="+arr)
  		}
  		else if(this.selectedbrands.length)
  		{
  			let arr = JSON.stringify(this.selectedbrands)
  			this.flows = await this.generalApiGetWithoutLoader("auditable_flows?selected_brands="+arr)
  		}
  		else if(this.selectedprojects.length)
  		{
  			let arr = JSON.stringify(this.selectedprojects)
  			this.flows = await this.generalApiGetWithoutLoader("auditable_flows?selected_projects="+arr)
  		}  		 
  		else
  		{
  			this.flows = await this.generalApiGetWithoutLoader("auditable_flows")
  		}
  		

  		this.flows_loading = false
  		await this.getAudits()
  		
  	},
  	async getAudits()
  	{
  		//this.loading_audits = true
  		this.loading = true
  		let selected_brands= JSON.stringify(this.selectedbrands)
  		let selected_projects= JSON.stringify(this.selectedprojects)
  		let selected_flows= JSON.stringify(this.selectedflows)
  		let data = await this.generalApiGetWithoutLoader("auditor_audits_verifications/"+this.$route.params.id+"/"+this.page+"?selected_brands="+selected_brands+"&selected_projects="+selected_projects+"&selected_flows="+selected_flows+"&start="+this.start_date+"&end="+this.end_date+"&searchterm="+this.searchterm)
  		console.log(data)
  		this.totalRecords = data.verifications.meta.total+data.audits.meta.total
  		this.parseAudits(data)
  		
  	},
  	parseAudits(data)
  	{
  		let verifications = data.verifications.data
  		let audits = data.audits.data
  		let all = verifications.concat(audits)
  		all = all.sort(function(a,b){
		  return new Date(b.date) - new Date(a.date);
		});
		console.log(all)
		this.audits = all

  		this.loading_audits = false;
  		this.loading = false
  	},


  }
}
</script>

<style lang="css" scoped>
</style>